import Swiper from 'swiper';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

// スムーススクロール
const smoothScroll = () => {
	const scrollTrigger = document.querySelectorAll('.js-smooth');

	for (let i = 0; i < scrollTrigger.length; i++) {
		scrollTrigger[i].addEventListener('click', ev => {
			ev.preventDefault();
			const navHeight = document.querySelector('header').clientHeight;
			const targetSection = scrollTrigger[i].getAttribute('href');

			const rect = document.querySelector(targetSection).getBoundingClientRect().top;
			const offset = window.pageYOffset;
			const gap = 20;
			const target = rect + offset - navHeight - gap;

			gsap.to(window, 1, {
				scrollTo: { y: target },
				ease: 'power4.out',

			});
		});
	};
};

// headerのマージンを自動で付与する
const headerMargin = () => {
	const header = document.querySelector('header');
	const headerHeight = header.clientHeight;
	const body = document.querySelector('body');
	const addMargin = document.querySelectorAll('.js-add-margin');

	body.style.paddingTop = headerHeight + 'px';

	for (let i = 0; i < addMargin.length; i++) {
		addMargin[i].style.marginTop = headerHeight + 'px';
	}
}

const worksSwiper = () => {
	const swiper = new Swiper(".works-swiper", {
		loop: true,
		slidesPerView: 1.4,
		speed: 2000,
		autoplay: {
			delay: 4000,
		},
		centeredSlides: true,
		breakpoints: {
			992: {
				slidesPerView: 2.4,
			}
		}
	});
}

const MvSwiper = () => {
	const swiper = new Swiper(".mv-swiper", {
		loop: true,
		slidesPerView: 1,
		speed: 2000,
		autoplay: {
			delay: 4000,
		},
		centeredSlides: true,
		pagination: {
			el: ".about-pagenation",
			type: "fraction"
		}
	});
}

const hamMenu = () => {
	const menu = document.querySelector('#menu');
	const menuBtn = document.getElementById('menu-btn');

	menuBtn.addEventListener('click', () => {
		if (menuBtn.classList.contains('active')) {
			menuBtn.classList.remove('active');
			menu.classList.remove('active');
		} else {
			menuBtn.classList.add('active');
			menu.classList.add('active');
		}
	});
}

window.addEventListener('load', () => {
	headerMargin();
	smoothScroll();
	worksSwiper();
	MvSwiper();
	hamMenu();
});
